module.exports = __webpack_public_path__ + "static/img/deporte.532d392.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/infografias/deporte.jpg
// module id = DptI
// module chunks = 1